import React, { useEffect, useState, useRef } from "react";
import "../../assets/css/tables.css";
import Swal from "sweetalert2";
import deletes from "../../assets/images/tablesImg/delete.png";
import testBluePng from "../../assets/images/courses/TestIcon.svg";
import more_vert from "../../assets/images/home/more_vert.png";
import { useHistory } from "react-router-dom";
import Repository from "../../configs/axios/repository";
import { handleGetTikets } from "../../redux/layout";
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import x_mark from "../../assets/images/courses/group.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Row, Col } from "reactstrap";
import copy from "../../assets/images/account/copy-regular.svg";
import { encrypt } from "../../utility/helpers/encrypt";
import ComponentSpinner from "../../@core/components/spinner/Loading-spinner";
import { v4 as uuidv4 } from "uuid";
import { openTest } from "../globalFunctions/openTest";

const customStyles = {
    content: {
        top: "50%",
        left: "52%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        background: "#F9FAFC 0% 0% no-repeat padding-box",
        padding: "20px 30px",
        width: "45%",
        zIndex: "9000",
        maxHeight: "600px",
    },
};

const TestsTable = ({
    tests,
    refreshTable,
    setLoadingData,
    loadingData,
    noteData,
    testType,
    canDoIt,
    note_id,
    notes,
    course_id,
    courseName,
}) => {
    const history = useHistory();
    const copyLinkRef = useRef(null);
    const [modalIsOpenForLink, setIsOpenForLink] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [testId, setTestId] = useState("");
    const [created, setCreated] = useState(false);
    const [guid, setGuid] = useState("");

    const [showErrorfirstName, setShowErrorFirstName] = useState(false);
    const [showErrorlastName, showErrorSetLastName] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);

    const dispatch = useDispatch();
    const role = useSelector((state) => state.layout.role);
    const deleteEvent = async (testId) => {
        const result = await Repository.deleteById(
            `api/test/deleteMultipleChoiceTest/${testId}`
        );
        if (result.data?.success == true) {
            refreshTable();
            loadingData
                ? Swal.fire(
                      "Deleted!",
                      "Your file has been deleted.",
                      "success"
                  )
                : "";
        }
    };
    const generateShortGuid = () => {
        const fullGuid = uuidv4();
        const shortGuid = fullGuid.substring(0, 12);

        return shortGuid;
    };

    const handleCreate = async (test_id) => {
        setCreated(true);
        let newGuid = generateShortGuid();
        setGuid(newGuid);
        let data = {
            one_time_guid: newGuid,
            is_passed: false,
            test_id: test_id,
        };
        const result = await Repository.postRequest(
            `api/anonymousResult/createAnonymousResult`,
            data
        );
        if (result.data?.success == true) {
            setCreated(true);
        } else {
            setIsOpenForLink(false);
        }
    };

    const handleCopyLink = () => {
        if (firstName != "" && lastName != "") {
            const range = document.createRange();
            const selection = window.getSelection();

            range.selectNode(copyLinkRef.current);
            selection.removeAllRanges();
            selection.addRange(range);

            document.execCommand("copy");
            selection.removeAllRanges();

            setAlertVisible(true);

            setTimeout(() => {
                setAlertVisible(false);
            }, 5000);
        }
        if (firstName == "") {
            setShowErrorFirstName(true);
        } else {
            setShowErrorFirstName(false);
        }

        if (lastName == "") {
            showErrorSetLastName(true);
        } else {
            showErrorSetLastName(false);
        }
    };

    function handleDelete(id) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoadingData(false);
                deleteEvent(id);
            }
            setLoadingData(true);
        });
    }
    function openTestFromCourse(file) {
        localStorage.setItem("isCreate", false);
        let testData = {
            test_id: file.test_id,
            test_name: file.test_name,
            test_content: JSON.parse(file.test_content),
            test_prompt: file.test_prompt,
            icon: file.icon,
            note_id: {
                note_id: file.note_id.note_id,
            },
            no_of_questions: file.no_of_questions,
            test_type: file.test_type,
        };
        dispatch(handleGetTikets(JSON.stringify(testData)));
        let array = JSON.parse(file.test_content);
        let note_id = file.note_id.note_id;
        let test_id = file.test_id;
        let isData = true;

        if (testType == "written") {
            history.push({
                pathname: "/resultViewWritten",
                state: {
                    array,
                    testType,
                    note_id,
                    isData,
                    noteData,
                    canDoIt,
                    test_id,
                    notes,
                    courseName,
                    course_id,
                },
            });
        } else {
            history.push({
                pathname: "/resultView",
                state: {
                    array,
                    testType,
                    note_id,
                    isData,
                    test_id,
                    noteData,
                    canDoIt,
                    notes,
                    courseName,
                    course_id,
                },
            });
        }
    }

    function openModalForLink(test_id) {
        setIsOpenForLink(true);
        handleCreate(test_id);
    }

    function closeModalForLink() {
        setIsOpenForLink(false);
        setFirstName("");
        setLastName("");
    }
    function encrypting(val) {
        return encrypt(
            `guid=${guid}&test_id=${testId}&course_name=${courseName}&first_name=${firstName}&last_name=${lastName}`
        );
    }
    const thumbs = tests?.map((file, i) => {
        return file ? (
            <div key={i}>
                <div
                    className="parentCoursesDiv"
                    onClick={(e) => {
                        if (role == "instructor") {
                            openTestFromCourse(file);
                        } else {
                            localStorage.setItem("isCreate", false);
                            openTest(
                                dispatch,
                                history,
                                file,
                                handleGetTikets,
                                noteData,
                                canDoIt
                            );
                        }
                    }}
                >
                    <div className="clidrenDivCompakt">
                        <div>
                            <img src={testBluePng} alt="testPng" />
                        </div>
                        <div className="mt-3">
                            <span>{file?.test_name}</span>
                            <p>
                                {" "}
                                {file?.test_type == "choice"
                                    ? "Multiple Choice"
                                    : file?.test_type == "written"
                                    ? "Written"
                                    : ""}
                            </p>
                        </div>
                    </div>
                </div>
                {role == "instructor" && canDoIt == false ? (
                    <div className="reslutBtnDiv">
                        <button
                            className="shareBtn"
                            onClick={() => {
                                openModalForLink(file.test_id);
                                setTestId(file.test_id);
                            }}
                        >
                            Share
                        </button>
                        <button
                            onClick={() => {
                                let note_id = file.note_id.note_id;
                                let test_id = file.test_id;
                                let isData = true;
                                history.push({
                                    pathname: "/result",
                                    state: {
                                        note_id,
                                        test_id,
                                        testType,
                                        canDoIt,
                                        noteData,
                                        isData,
                                        course_id,
                                        courseName,
                                    },

                                    search: `test_id=${file.test_id}&note_id=${note_id}`,
                                });
                            }}
                        >
                            Results
                        </button>
                    </div>
                ) : (
                    ""
                )}{" "}
                {(role == "instructor" && canDoIt == false) ||
                (role == "student" && canDoIt == true) ? (
                    <div className="parentDelete">
                        <div className="childDiv">
                            <div>
                                <UncontrolledDropdown className="dropdown-user nav-item actionContent">
                                    <DropdownToggle
                                        tag="a"
                                        className="nav-link dropdown-user-link pointsInTeam pointDiv"
                                    >
                                        <img
                                            src={more_vert}
                                            alt="points"
                                            className="pointImg"
                                        />
                                    </DropdownToggle>

                                    <DropdownMenu
                                        end
                                        id="pointDropdownTest"
                                        className="dropMenu "
                                    >
                                        <DropdownItem
                                            onClick={(e) => {
                                                handleDelete(file?.test_id);
                                            }}
                                        >
                                            <div className="actionsMenu">
                                                <img
                                                    src={deletes}
                                                    alt="deletes"
                                                />
                                                <span>Delete</span>
                                            </div>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        ) : (
            ""
        );
    });
    return (
        <div>
            <div className="divTable">{thumbs}</div>
            <Modal
                isOpen={modalIsOpenForLink}
                onRequestClose={closeModalForLink}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div>
                    <div className="showNotes">
                        <h2>Link for invite</h2>
                        <img
                            src={x_mark}
                            onClick={closeModalForLink}
                            className="closeModalImg"
                        />
                    </div>
                    {created ? (
                        <div>
                            <Row>
                                <Col xl="12" md="12" sm="12">
                                    <input
                                        className="formikInput"
                                        type="text"
                                        name="first_name"
                                        placeholder="First name*"
                                        value={firstName}
                                        onChange={(e) => {
                                            setFirstName(e.target.value);
                                            setShowErrorFirstName(false);
                                        }}
                                    />
                                    <div
                                        className={
                                            showErrorfirstName
                                                ? "errorMessage"
                                                : "notShow"
                                        }
                                    >
                                        First name is required.
                                    </div>
                                </Col>
                                <Col xl="12" md="12" sm="12">
                                    <input
                                        className="formikInput"
                                        type="text"
                                        name="last_name"
                                        placeholder="Last name*"
                                        value={lastName}
                                        onChange={(e) => {
                                            setLastName(e.target.value);
                                            showErrorSetLastName(false);
                                        }}
                                    />
                                    <div
                                        className={
                                            showErrorlastName
                                                ? "errorMessage"
                                                : "notShow"
                                        }
                                    >
                                        Last name is required.
                                    </div>
                                </Col>
                                <Col xl="12" md="12" sm="12">
                                    <div className="paymentInfoContent copyLink mt-2 mb-4">
                                        <div className="linkContent">
                                            <span
                                                ref={copyLinkRef}
                                                className="copyLink "
                                            >
                                                {`${
                                                    process.env
                                                        .REACT_APP_FRONT_ENDPOINT
                                                }completeTest?token=${encrypting()}`}
                                            </span>
                                        </div>
                                        <div className="copySectionTest">
                                            <img
                                                onClick={handleCopyLink}
                                                src={copy}
                                                alt="copy"
                                                style={{
                                                    cursor: "pointer",
                                                    margin: "8px",
                                                }}
                                            />
                                            {alertVisible && (
                                                <div className="copyLinkItem">
                                                    Link copied!
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        <ComponentSpinner spiner={true} />
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default TestsTable;
